<template>
  <div id="call_campaign_status_panel">
    <CustomContainer>
      <div
        class="flex flex-col overflow-y-scroll h-80"
        @scroll="handleScroll"
        ref="scrollContainer"
      >
        <SkeletonLoader v-if="loading" :page="loaderPages.TABLE" />

        <template v-else>
          <div v-if="statusList?.length > 0" class="flex flex-col">
            <div
              v-for="(item, index) in statusList"
              :key="`${item.id}_item_${index}`"
              class="flex flex-row justify-between items-center p-2"
            >
              <div class="flex flex-row gap-2 items-center">
                <ProfileIcon :size="40" :data="item" />
                <div class="flex flex-col gap-1">
                  <span v-if="item?.name" class="font-base font-semibold">{{
                    item?.name
                  }}</span>
                  <span v-if="item?.current_role" class="font-sm">{{
                    item?.current_role
                  }}</span>
                </div>
              </div>
            </div>

            <SkeletonLoader
              v-if="loadingMore"
              :page="loaderPages.CAMPAIGN_VIEW_DETAILS"
            />
          </div>

          <EmptyScreen
            v-else
            padding="my-[10vh]"
            text="No leads found!!"
            source="call_campaign_status_panel"
          />
        </template>
      </div>
    </CustomContainer>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import CustomContainer from "@/src/components/CustomContainer.vue";
import ProfileIcon from "@/src/components/ProfileIcon.vue";
import SkeletonLoader from "@/src/components/SkeletonLoader.vue";
import { loaderPages } from "@/src/constants/loaderConstants.js";
import EmptyScreen from "@/src/components/EmptyScreen.vue";

const props = defineProps({
  data: { type: Array, required: true },
  loading: { type: Boolean, default: false },
  loadingMore: { type: Boolean, default: false },
  hasMore: { type: Boolean, default: false },
});

const emit = defineEmits(["load-more"]);
const scrollContainer = ref(null);
const statusList = computed(() => props.data);

const handleScroll = (event) => {
  const { scrollTop, scrollHeight, clientHeight } = event.target;
  if (
    scrollHeight - scrollTop <= clientHeight + 1 &&
    !props.loadingMore &&
    props.hasMore
  ) {
    emit("load-more");
  }
};
</script>
